<!-- 腾讯视频 -->
<template>
  <div>
    <div>
    <!-- 预约之前显示的样式 -->
    <div class="before-appointment" style="background-color:#333333;padding:32px 0;" v-if="appDetail.statu==='TO_BE_COMPLETE_MENTOR'||appDetail.statu==='TO_BE_COMPLETE_MENTEE'">
      <div style="width:1280px;margin:0 auto;">
        <!-- 辅导时间 -->
        <div class="tencent-video-detail" style="padding-left:160px;">
          <tencent-video-time-before-confirm :appDetail="appDetail"
                              :isPackageId="isPackageId"
                              :isLinkVideo="video"
                              @on-close="endAppTime"
                              :usedTime="usedDuration"></tencent-video-time-before-confirm>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="tencent-video">
        <div>
          <!-- 远端大窗口 -->
          <div class="tencent-video-left">
            <div class="tencent-video-mentor"
                 style="margin-top:0;">
              <img :src="videoImg"
                   alt=""
                   v-show="!isNotTimeModal && !remoteVideoStream && !remoteVideoStream">
              <div class="tencent-video-prompt"
                   v-show="!!videoPrompt">{{ videoPrompt }}</div>
              <div id="tencent-video-mentor"
                   class="trtc-video-mentor"
                   v-show="remoteVideoStream || remoteSharingStream"></div>
              <!-- 未到进入时间的提示弹窗 -->
              <div class="not-time-modal" v-if="isNotTimeModal">
                <div>
                  Hello, the video call has not started yet, please enter 10 minutes<br> before the video starts.
                </div>
                <div class="line-block"></div>
                <div class="not-time-start">
                  Video call starts at : {{appDetail.mentorResultTimeStr}} ({{appDetail.mentorZone | zoneTitleMap}})
                </div>
              </div>
            </div>
            <div class="bottom-btn-box bottom-btn-box-left">
              <div class="tencent-bottom-btn"
                   @click="handleRtcShareScreen"
                   id="screen-btn"
                   v-show="!remoteSharingStream && video">
                <div class="img-box"><img :src="localSharingStream ? shareOffImg : shareOnImg"
                                          alt="Screen sharing"
                                          id="screen-img"></div>
                <div class="tip-font"
                     id="screen-html">Screen sharing</div>
              </div>
              <div class="tencent-bottom-btn"
                   @click="handleFullscreen"
                   v-show="remoteVideoStream || remoteSharingStream">
                <div class="img-box"><img :src="screenImg"
                                          alt="Full  screen"></div>
                <div class="tip-font">Full screen</div>
              </div>
              <div class="tencent-bottom-btn no-margin-right"
                   v-show="!remoteVideoStream && !remoteSharingStream">
                <a target="_blank"
                   title="Detection device"
                   href="https://web.sdk.qcloud.com/trtc/webrtc/demo/detect/index.html"
                   style="display: flex;flex-direction: column;align-items: center;">
                  <div class="img-box"><img :src="jianceImg"
                                            alt="Detection device"></div>
                  <div class="tip-font">Detection device</div>
                </a>
              </div>
            </div>
            <div class="bottom-btn-box bottom-btn-box-right">
              <div class="tencent-bottom-btn"  v-if="localVideoStream && (localVideoStream.getAudioTrack()) && hasMic" @click="handleMicMuted">
                <div class="img-box"><img :src="isMicMuted ? mutedImg :cancelMutedImg " alt="麦克风"></div>
                <div class="tip-font">Microphone</div>
              </div>
              <div class="tencent-bottom-btn no-margin-right"  v-if="localVideoStream && (localVideoStream.getVideoTrack()) && hasCamera" @click="handleCameraMuted">
                <div class="img-box"><img :src="(!isCarmerMuted) ?  cameraImg : cancelCameraImg " alt="摄像头"></div>
                <div class="tip-font">Camera</div>
              </div>
            </div>
          </div>
          <div class="tencent-video-right">
            <!-- 本地小窗口 -->
            <div class="tencent-video-mentee dis-24"
                 style="height:160px;">
              <img :src="logoImg"
                   alt=""
                   v-show="!localVideoStream">
              <div id="tencent-video-mentee"
                   class="trtc-video-mentee"
                   v-show="localVideoStream"></div>
            </div>
            <!-- 远端小窗口 -->
            <div class="tencent-video-mentee dis-24"
                 style="height:160px;"
                 v-show="remoteSharingStream">
              <div id="tencent-video-mentor-small"
                   class="trtc-video-mentee"></div>
            </div>
            <!-- 辅导时间 -->
            <div class="tencent-video-detail">
              <tencent-video-time :appDetail="appDetail"
                                  :isPackageId="isPackageId"
                                  :isLinkVideo="video"
                                  @on-close="endAppTime"
                                  :usedTime="usedDuration"></tencent-video-time>
            </div>
          </div>
        </div>
      </div>
      <div v-if="video" style="width: 1280px; margin: 12px auto 0;">
        <div style="width: 960px;">
          <Row>
            <Col :span="12" align="center">
              <Select v-model="currentVideoDeviceId" style="width: 80%" placeholder="摄像头" not-found-text="未找到摄像头设备" @on-change="changeVideoDevice">
                <Option :key="'videoDevice' + item.deviceId" v-for="item in cameraList" :value="item.deviceId">{{ item.label }}</Option>
              </Select>
            </Col>
            <Col :span="12" align="center" >
              <Select v-model="currentAudioDeviceId" style="width: 80%" placeholder="麦克风" not-found-text="未找到麦克风设备" @on-change="changeAudioDevice">
                <Option :key="'audioDevice' + item.deviceId" v-for="item in micList" :value="item.deviceId">{{ item.label }}</Option>
              </Select>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    </div>
    <!-- 弹窗建议谷歌浏览器 -->
    <zlr-modal v-model="showChromeWarning"
               :mask-closable=false>
      <div class="prompt-chrome">
        <h2>In order to provide you with a better MSP service experience, we strongly recommend that you use Google Chrome browser ( Version 72 or later ) !</h2>
        <h2><strong style="color:red;">Not available:</strong> IOS browser, video call through mobile </h2>
        <div>
          <img :src="chrome"
               alt="">
        </div>
        <Button class="btn"
                @click="showChromeWarning=false">Close</Button>
      </div>
    </zlr-modal>
    <!-- 浏览器报错指导教程-->
    <div class="tutorial-modal-box">
    <zlr-modal v-model="isTutorialTip"
             :mask-closable=false>
        <div style="width:100%;">
          <video-check-tutorial></video-check-tutorial>
          <div class="btn-center" style="margin-bottom:45px;">
            <Button class="btn"
              @click="isTutorialTip=false">Close</Button>
          </div>
        </div>
    </zlr-modal>
    </div>
    <!--暂时无法访问摄像头/麦克风，请确保系统允许当前浏览器访问摄像头/麦克风，并且没有其他应用占用摄像头/麦克风  -->
    <!-- NotReadableError -->
    <div class="err-modal-box">
      <zlr-modal v-model="isModalError"
              :mask-closable=false>
          <div style="width:100%;">
            <div class="err-modal-box-content">
              <div v-if="modalErrorContent==='NotReadableError'">
                The camera/microphone is temporarily unavailable. <br>Please ensure that the current browser is able to access <br>the camera/microphone and no other applications are <br>occupying the camera/microphone.
              </div>
              <div v-if="modalErrorContent==='NotAllowedError'">
               Please make sure the current browser is able to access the camera/microphone.
              </div>
              <div v-if="modalErrorContent==='NotAllowedErrorOther'">
                Please allow current browser to access the camera/microphone.
              </div>
              <div v-if="modalErrorContent==='NotFoundError'">
               The browser is having trouble detecting the camera/microphone device. <br>Please check the web connection and make sure your current browser<br> is able to access the camera/microphone.
              </div>
              <div v-if="modalErrorContent==='NoMicrophone'">
                The browser is having trouble detecting the microphone device. <br>Please check the web connection and make sure your current browser<br> is able to access the microphone.
              </div>
              <div v-if="modalErrorContent==='NoCamera'">
                The browser is having trouble detecting the camera device. <br>Please check the web connection and make sure your current browser<br> is able to access the camera.
              </div>
              <div v-if="modalErrorContent==='RtcError'">
                Network is abnormal, check the network, firewall, VPN, or other network proxy
              </div>
              <div v-if="modalErrorContent==='TypeError'">
                At least one of camera/microphone must be requested
              </div>
            </div>
            <div class="btn-center" style="margin-bottom:45px;">
              <Button class="btn"
                @click="isModalError=false">Close</Button>
            </div>
          </div>
      </zlr-modal>
    </div>
  </div>
</template>

<script>
// api
import { getVideoUserSign, getScreenVideoUserSign } from '@/api/video'
import { subAppVideoFinish } from '@/api/appointment'
import url from '_conf/url'
import { getToken } from '@/libs/util'
// less
import './index.less'
// components
import TencentVideoTime from './tencent-video-time'
import ZlrModal from '_c/modal/modal'
import VideoCheckTutorial from './video-check-tutorial'
// images
import videoImg from '@/assets/images/video/Video.svg'
import logoImg from '@/assets/images/video/Logo.svg'
import screenImg from '@/assets/images/video/screenImg.svg'
import shareOnImg from '@/assets/images/video/shareOnImg.svg'
import shareOffImg from '@/assets/images/video/shareOffImg.svg'
import jianceImg from '@/assets/images/video/shebeijiance.svg'
import chrome from '@/assets/images/home/Chrome.svg'
import mutedImg from '@/assets/images/video/jingyin.svg'
import cancelMutedImg from '@/assets/images/video/jiechujingyin.svg'
import cameraImg from '@/assets/images/video/kaiqishexiangtou.svg'
import cancelCameraImg from '@/assets/images/video/guanbishexiangtou.svg'
// 腾讯api
import TRTC from 'trtc-js-sdk'
import TencentVideoTimeBeforeConfirm from './tencent-video-time-before-confirm'
import rtcLogService from '@/api/rtc/rtc-log'

export default {
  name: 'tencent-video',
  components: {
    TencentVideoTime,
    ZlrModal,
    VideoCheckTutorial,
    TencentVideoTimeBeforeConfirm
  },
  props: ['appDetail', 'isPackageId'],
  data () {
    return {
      videoImg,
      logoImg,
      // 图片
      screenImg,
      shareOnImg,
      shareOffImg,
      jianceImg,
      chrome,
      mutedImg,
      cancelMutedImg,
      cameraImg,
      cancelCameraImg,
      video: false,
      // 视频上的提示文案
      videoPrompt: '',
      // 谷歌浏览器弹窗
      showChromeWarning: true,
      // 未到进入时间的提示弹窗
      isNotTimeModal: false,
      // 浏览器报错指导教程
      isTutorialTip: false,
      // 错误弹窗
      isModalError: false,
      modalErrorContent: '',

      keepaliveInterval: undefined,
      usedDurationInterval: undefined,
      usedDuration: 0,

      cameraList: [],
      micList: [],
      currentVideoDeviceId: undefined,
      currentAudioDeviceId: undefined,
      hasCamera: false,
      hasMic: false,
      videoClient: undefined,
      sharingScreenClient: undefined,
      localVideoUserId: undefined,
      localSharingUserId: undefined,
      localVideoStream: undefined,
      localSharingStream: undefined,
      // 远端
      remote: false,
      remoteVideoUserId: undefined,
      remoteSharingUserId: undefined,
      remoteVideoStream: undefined,
      remoteSharingStream: undefined,
      websocket: undefined,
      // 开关麦克风摄像头
      isMicMuted: false,
      isCarmerMuted: false
    }
  },
  mounted () {
    const self = this
    // 校验
    this.validateAppointmentStatus()
    // 判断是否提前了10分钟以上
    if (new Date(self.appDetail.resultTime).getTime() - Date.now() > (10 * 60 * 1000)) {
      this.isNotTimeModal = true
      const p = setInterval(() => {
        if (new Date(self.appDetail.resultTime).getTime() - Date.now() < (10 * 60 * 1000)) {
          this.init()
          clearInterval(p)
        }
      }, 1000)
    } else {
      this.init()
    }
  },
  methods: {
    async init () {
      this.info('开始初始化' + navigator.userAgent, 'APP')
      this.video = true
      const self = this
      this.isNotTimeModal = false
      await this.initMedia()
      await this.initRtc()
      this.initWebSocket()
      self.usedDurationInterval = setInterval(() => {
        self.usedDuration += (self.remote ? 1 : 0)
      }, 1000)
    },
    async initMedia () {
      this.cameraList = await TRTC.getCameras()
      this.micList = await TRTC.getMicrophones()
      this.hasCamera = this.cameraList && this.cameraList.length > 0
      this.hasMic = this.micList && this.micList.length > 0
      try {
        await navigator.mediaDevices.getUserMedia({ video: this.hasCamera, audio: this.hasMic })
      } catch (e) {
        this.handleGetUserMediaError(e)
      }
      if (this.hasCamera) {
        this.currentVideoDeviceId = this.cameraList[0].deviceId
      } else {
        this.warn('未找到摄像头', 'Device')
      }
      if (this.hasMic) {
        this.currentAudioDeviceId = this.micList[0].deviceId
      } else {
        this.warn('未找到麦克风', 'Device')
      }
    },
    async initRtc () {
      // 创建客户端
      this.videoClient = await this.createClient('VIDEO')
      // 监听事件
      this.listen()

      await this.videoClient.join({ roomId: this.appDetail.id })

      await this.initLocalVideo()

      this.startVideoMixStream(this.appDetail.id)
    },
    listen () {
      const self = this
      const client = this.videoClient

      client.on('stream-added', event => {
        const remoteStream = event.stream
        const remoteUserId = remoteStream.getUserId()
        console.log('添加流：' + remoteUserId)
        self.warn('添加流：' + remoteUserId, 'TRTC')
        if (remoteUserId === self.localVideoUserId || remoteUserId === self.localSharingUserId) {
          // 取消订阅自己发布的流
          client.unsubscribe(remoteStream)
        } else {
          client.subscribe(remoteStream)
        }
      })

      // 远端流订阅成功事件，调用 subscribe() 成功后会触发该事件。
      client.on('stream-subscribed', event => {
        console.log('订阅成功')
        const remoteStream = event.stream
        const remoteUserId = remoteStream.getUserId()
        self.warn('订阅成功：' + remoteUserId, 'TRTC')
        let isScreenShare = remoteUserId.indexOf('_sharing') !== -1

        if (isScreenShare) {
          self.remoteSharingStream = remoteStream
          self.remoteSharingUserId = remoteUserId
          if (self.remoteVideoStream) {
            self.remoteVideoStream.stop()
            self.remoteVideoStream.play('tencent-video-mentor-small')
          }
          self.remoteSharingStream.play('tencent-video-mentor')
        } else {
          self.remoteVideoStream = remoteStream
          self.remoteVideoUserId = remoteUserId
          if (self.remoteSharingStream) {
            self.remoteVideoStream.play('tencent-video-mentor-small')
          } else {
            self.remoteVideoStream.play('tencent-video-mentor')
          }
        }

        self.remote = true
        console.log(self.remote ? '远端在线' : '远端离线')
      })

      // 远端流移除事件，当远端用户取消发布流后会收到该通知。
      client.on('stream-removed', event => {
        console.log('远端流移除事件')
        const remoteStream = event.stream
        const remoteUserId = remoteStream.getUserId()
        self.warn('远端流移除事件：' + remoteUserId, 'TRTC')
        if (remoteUserId !== self.remoteVideoUserId && remoteUserId !== self.remoteSharingUserId) {
          return
        }
        let isScreenShare = remoteUserId.indexOf('_sharing') !== -1

        if (isScreenShare) {
          if (self.remoteSharingStream) {
            self.remoteSharingStream.stop()
          }
          self.remoteSharingUserId = undefined
          self.remoteSharingStream = undefined
          if (self.remoteVideoStream) {
            self.remoteVideoStream.stop()
            self.remoteVideoStream.play('tencent-video-mentor')
          }
        } else {
          self.remoteVideoStream.stop()
          self.remoteVideoUserId = undefined
          self.remoteVideoStream = undefined
        }

        if (!self.remoteVideoStream && !self.remoteSharingStream) {
          self.remote = false
        }
        console.log(self.remote ? '远端在线' : '远端离线')
      })

      client.on('mute-audio', event => {
        self.$Message.info('Mute the other party')
      })
      client.on('mute-video', event => {
        self.$Message.info('Their cameras are off')
      })
      client.on('unmute-audio', event => {
        self.$Message.info('Unmute the other party')
      })
      client.on('unmute-video', event => {
        self.$Message.info("The other party's camera is on")
      })
    },
    async initLocalVideo () {
      const streamParams = {
        userId: this.localVideoUserId,
        video: this.hasCamera,
        audio: this.hasMic
      }
      if (this.hasCamera) {
        streamParams.cameraId = this.currentVideoDeviceId
      }
      if (this.hasMic) {
        streamParams.microphoneId = this.currentAudioDeviceId
      }
      this.localVideoStream = await TRTC.createStream(streamParams)
      await this.localVideoStream.initialize()
      this.localVideoStream.setVideoProfile({ width: 960, height: 540, frameRate: 30, bitrate: 1600 })
      this.isMicMuted = this.localVideoStream.muteAudio()
      await this.localVideoStream.play('tencent-video-mentee')
      await this.videoClient.publish(this.localVideoStream)
    },
    async changeVideoDevice (value) {
      if (value) {
        await this.localVideoStream.switchDevice('video', value)
      }
    },
    async changeAudioDevice (value) {
      if (value) {
        this.localVideoStream.switchDevice('audio', value)
      }
    },
    initWebSocket () {
      let baseUrl = url.replace(/(http)|(https)/, 'ws')
      let id = this.appDetail.id
      let token = getToken()
      const wsUrl = `${baseUrl}/websocket/tencent/rtc/${id}/${token}`
      this.websocket = new WebSocket(wsUrl)
      this.websocket.onopen = this.webSocketOnOpen
      this.websocket.onmessage = this.webSocketOnMessage
      this.websocket.onclose = () => {
        console.log('websocket 断开')
      }
    },
    closeWebSocket () {
      if (this.keepaliveInterval) {
        clearInterval(this.keepaliveInterval)
      }
      if (this.websocket) {
        this.websocket.close()
      }
    },
    webSocketOnMessage (e) {
      if (!e.data) {
        return
      }
      const webSocketMessage = JSON.parse(e.data)
      console.log(webSocketMessage)
      if (webSocketMessage && webSocketMessage.type && (webSocketMessage.type !== 'HEARTBEAT') && (webSocketMessage.type !== 'KEEPALIVE')) {
        this.warn(e.data, 'WebSocket')
      }
      let message
      switch (webSocketMessage.type) {
        case 'USED_DURATION':
          this.usedDuration = webSocketMessage.usedDuration
          break
        case 'FINISH_MEETING':
          message = 'Real-Time chat has been close by mentee'
          this.end()
          break
        case 'VIDEO_CLOSE_TIME_FINISH':
          message = 'Please note that the package time has been used up'
          break
        case 'VIDEO_MENTEE_OVERTIME':
          message = 'Mentee have not entered for more than 10 mins, Real-Time chat was automatically closed.'
          break
        default:
          break
      }
      this.videoPrompt = message
      let p = setTimeout(() => {
        this.videoPrompt = ''
        clearTimeout(p)
      }, 5000)
    },
    webSocketOnOpen () {
      const self = this
      self.keepaliveInterval = setInterval(() => {
        self.websocket.send(JSON.stringify({ type: 'KEEPALIVE', online: self.remote }))
      }, 5000)
    },
    async handleRtcShareScreen () {
      if (!this.localSharingStream) {
        await this.startSharingScreen()
      } else {
        await this.stopSharingScreen()
      }
    },
    async startSharingScreen () {
      const self = this
      this.sharingScreenClient = await this.createClient('SHARING_SCREEN')

      // 屏幕共享客户端，不订阅任何流，只用来进行推流
      this.sharingScreenClient.on('stream-added', event => {
        self.sharingScreenClient.unsubscribe(event.stream)
      })

      await this.sharingScreenClient.join({ roomId: this.appDetail.id })

      this.localSharingStream = await TRTC.createStream({
        userId: this.localSharingUserId,
        audio: false,
        screen: true
      })

      this.localSharingStream.on('screen-sharing-stopped', event => {
        self.stopSharingScreen()
      })

      try {
        await this.localSharingStream.initialize()
        await this.sharingScreenClient.publish(this.localSharingStream)
      } catch (e) {
        if (e.name.includes('NotAllowedError')) {
          await this.localSharingStream.stop()
          await this.localSharingStream.close()
          await this.sharingScreenClient.leave()
          this.sharingScreenClient = undefined
          this.localSharingStream = undefined
          this.localSharingUserId = undefined
        } else {
          console.error(e)
        }
      }
    },
    handleGetUserMediaError (e) {
      this.error(e.name, 'WebRTC')
      if (e.name.includes('NotReadableError')) {
        this.modalErrorContent = 'NotReadableError'
      } else if (e.name.includes('NotAllowedError')) {
        if (e.message.includes('Permission denied by system')) {
          this.modalErrorContent = 'NotAllowedError'
        } else {
          this.isTutorialTip = true
        }
      } else if (e.name.includes('NotFoundError')) {
        this.modalErrorContent = 'NotFoundError'
      } else if (e.name.includes('RtcError')) {
        if (e.message.includes('no microphone detected')) {
          this.modalErrorContent = 'NoMicrophone'
        } else if (e.message.includes('no camera detected')) {
          this.modalErrorContent = 'NoCamera'
        } else {
          this.modalErrorContent = 'RtcError'
        }
      } else if (e.name.includes('TypeError')) {
        this.modalErrorContent = 'TypeError'
      }
      if (!this.isTutorialTip) {
        this.isModalError = true
      }
    },
    startVideoMixStream (roomId) {
      /* startVideoMixStream({ id: roomId }).then((res) => {
        if (res.code === 0) {
          console.log('混流成功')
        } else {
          console.log('混流失败')
        }
      }) */
    },
    endAppTime () {
      subAppVideoFinish({
        id: this.appDetail.id
      }).then(res => {
        this.end()
      })
    },
    handleFullscreen () {
      let mentorDom = document.getElementById('tencent-video-mentor')
      mentorDom.webkitRequestFullScreen()
    },
    // 麦克风
    handleMicMuted () {
      this.isMicMuted = !this.isMicMuted
      this.isMicMuted ? this.localVideoStream.muteAudio() : this.localVideoStream.unmuteAudio()
    },
    // 摄像头
    handleCameraMuted () {
      this.isCarmerMuted = !this.isCarmerMuted
      this.isCarmerMuted ? this.localVideoStream.muteVideo() : this.localVideoStream.unmuteVideo()
    },
    validateAppointmentStatus () {
      if (!this.appDetail) {
        throw new Error('预约信息不能为空')
      }
      if (!['INCOMPLETE', 'TO_FEEDBACK'].includes(this.appDetail.statu)) {
        throw new Error('预约状态错误')
      }
      if (this.appDetail.tencentInfo && this.appDetail.tencentInfo.finish) {
        throw new Error('视频已结束')
      }
    },
    async createClient (type) {
      let params
      if (type === 'VIDEO') {
        const { code, data, message } = await getVideoUserSign({})
        if (code === 0) {
          this.localVideoUserId = data.userId
          params = data
        } else {
          this.$Message.error(message)
        }
      } else if (type === 'SHARING_SCREEN') {
        const { code, data, message } = await getScreenVideoUserSign({})
        if (code === 0) {
          this.localSharingUserId = data.userId
          params = data
        } else {
          this.$Message.error(message)
        }
      }
      return TRTC.createClient({
        mode: 'rtc',
        sdkAppId: params.sdkAppId,
        userId: params.userId,
        userSig: params.urlSig
      })
    },
    end () {
      this.warn('视频结束', 'APP')
      this.video = false
      this.stopSharingScreen()
      this.stopVideo()
      this.closeWebSocket()
      if (this.usedDurationInterval) {
        clearInterval(this.usedDurationInterval)
      }
    },
    async stopSharingScreen () {
      if (this.localSharingStream) {
        await this.localSharingStream.stop()
        await this.localSharingStream.close()
      }
      if (this.sharingScreenClient) {
        if (this.localSharingStream) {
          await this.sharingScreenClient.unpublish(this.localSharingStream)
        }
        await this.sharingScreenClient.leave()
      }
      this.sharingScreenClient = undefined
      this.localSharingStream = undefined
      this.localSharingUserId = undefined
    },
    async stopVideo () {
      if (this.localVideoStream) {
        await this.localVideoStream.stop()
        await this.localVideoStream.close()
      }
      if (this.videoClient) {
        if (this.localVideoStream) {
          await this.videoClient.unpublish(this.localVideoStream)
        }
        await this.videoClient.leave()
      }
      this.videoClient = undefined
      this.localVideoStream = undefined
      this.localVideoUserId = undefined
    },
    debug (log, tags) {
      rtcLogService.debug(log, this.appDetail.id, tags)
    },
    info (log, tags) {
      rtcLogService.info(log, this.appDetail.id, tags)
    },
    warn (log, tags) {
      rtcLogService.warn(log, this.appDetail.id, tags)
    },
    error (log, tags) {
      rtcLogService.error(log, this.appDetail.id, tags)
    }
  },
  beforeDestroy () {
    this.closeWebSocket()
    if (this.usedDurationInterval) {
      clearInterval(this.usedDurationInterval)
    }
  }
}
</script>
<style lang='less' scoped>
.tencent-share-screen-btn {
  color: #6589dd;
  padding: 7px 0;
  cursor: pointer;
  margin-top: 20px;
  background-color: #ffffff;
  width: 120px;
  margin-left: 24px;
  text-align: center;
  font-size: 12px;
  border-radius: 2px;
}

.bottom-btn-box {
  display: flex;
  position: absolute;
  bottom: 28px;
  .tencent-bottom-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 70px;
    cursor: pointer;
    .img-box {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      background: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        height: 17px;
        width: auto;
      }
    }
    .tip-font {
      padding-top: 8px;
      font-weight: 500;
      color: #ffffff;
      text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
    }
  }
  .no-margin-right{
    margin-right:0;
  }
}
.bottom-btn-box-left{
  left:120px;
}
.bottom-btn-box-right{
  right:120px;
}
//新代码
.trtc-video-mentee{
  height:150px;
  margin:5px 20px;
}
.trtc-video-mentor{
  height:560px;
  margin-top:5px;
}
// 建议用谷歌
.prompt-chrome {
  padding: 32px 0;
  width: 640px;
  text-align: center;
  h2 {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
    text-align: center;
    line-height: 30px;
    margin-bottom: 24px;
    font-weight: normal;
  }
  img {
    width: 96px;
  }
  .btn {
    margin-top: 36px;
    background-color: #fff;
    border-color: @c-primary;
    color: @c-primary;
    width: 96px;
  }
}
//未到时间进入
.not-time-modal{
  position:absolute;
  left:50%;
  top:21%;
  transform: translateX(-50%);
  color:#ffffff;
  font-size:24px;
  font-weight: 600;
  width: 100%;
  text-align: center;
  .line-block{
    width: 46px;
    height: 1px;
    background-color:#74CEF4;
    margin:20px auto;
  }
  .not-time-start{
    font-size:18px;
    text-align:center;
  }
}
//授权
.btn-center{
  text-align:center;
}
//错误弹窗
.err-modal-box{
  &-content{
  font-size:26px;
  padding:50px;
  color:red;
  text-align:center;
  }
}
</style>
<style>
.tutorial-modal-box .zlr-modal .zlr-modal-main{
  padding-top:0;
}
</style>
